import React from "react";
import {registerPassages, jumpTo} from "../../Utils";
import {addTimePart, changeTimeTo, notify} from "../features/functions";
import Passage from "../../features/Passage";
import Link from "../../features/Link";
import V from "../../features/V";
import Image from "../../features/Image";
import images, {getRandomImage} from "../images";
import variables from "../variables";
import places from "../places/places";
import people, {currentPlayer} from "../people/people";
import Video from "../../features/Video";
import missions from "../missions";
import Say from "../../features/Say";
import constants from "../constants";
import things from "../things";
import Name from "../../features/Name";
import {Trans} from "react-i18next";

registerPassages({
    pillsReadInstruction: <Passage>
        <Trans i18nKey="game.pillsInstruction.header">1<h1/></Trans>
        <Image src={images.story.readInstructions}/>
        <Trans i18nKey="story.pillsReadInstruction.part1">1<Name who={people.wife}/></Trans>
        <div style={{color: "orange", backgroundColor: "white", padding: "5px"}}>
            <Trans i18nKey="game.pillsInstruction.body">1<h3/><div style={{color: "red"}}/><strong/></Trans>
        </div>
        <Trans i18nKey="story.pillsReadInstruction.part2">
            1<Name who={people.wife}/>
            <Link to="" callback={()=>{
                addTimePart(true);
                missions.initCorruption_01.finishCurrentTask();
                currentPlayer.goTo(places.homeBedroom.id);}}/>
        </Trans>
    </Passage>,

    getWifeInfoAboutDrink: <Passage>
        <Trans i18nKey="story.getWifeInfoAboutDrink">
            1<h1/>
            <V callback={()=>{
                if (people.wife.relations <= 13)
                    jumpTo("story.getWifeInfoAboutDrinkFailure")
            }} />
            <Image src={getRandomImage(images.wife.actions.speak)}/><Say who={people.wife}/>
            <span style={{fontWeight: "bold", color: "orange"}}/>
            <Link to="" callback={() => {
                missions.initCorruption_01.finishCurrentTask();
                currentPlayer.goTo(people.wife.where);
                addTimePart(true);}}/>{{wife: people.wife.name}}
        </Trans>
    </Passage>,

    getWifeInfoAboutDrinkFailure: <Passage>
        <Trans i18nKey="story.getWifeInfoAboutDrinkFailure">
            1<h1/><Image src={images.wife.actions.argue.arguing2_no}/><div style={{color: "red"}}/><br/>
            <Link to="" callback={() => {
                currentPlayer.goTo(people.wife.where);
                addTimePart(true);}}/>{{wife: people.wife.name}}
        </Trans>
    </Passage>,

    rentPayment: <Passage>
        <Trans i18nKey="story.rentPayment.main">
            1<h1/><Image src={images.game.homeOwner1}/><Name who={people.apartments01Keeper}/>
            <Say who={people.apartments01Keeper}/><Say who={people.player}/>
            {{keeper: people.apartments01Keeper.name}}
        </Trans><br/><br/>
        <V callback={()=>{
            return people.player.money < 600 ?
                <Trans i18nKey="story.rentPayment.link1">1<Link to="story.rentPaymentFailure"/></Trans> :
                <Trans i18nKey="story.rentPayment.link2">1<Link to="story.rentPaymentSuccess"/></Trans>
        }}/>
    </Passage>,

    rentPaymentSuccess: <Passage>
        <Trans i18nKey="story.rentPaymentSuccess">
            1<h1/><Image src={images.game.homeOwner1}/><Say who={people.apartments01Keeper}/><Say who={people.player}/>
            <Name who={people.apartments01Keeper}/>
            <Link to="" callback={()=>{
                people.player.set("money", people.player.money - constants.homes.apartments01.payment);
                variables.game.rentPayed = true;
                currentPlayer.goTo(places.homeBedroom.id);}}/>
        </Trans>
    </Passage>,

    rentPaymentFailure: <Passage>
        <Trans i18nKey="story.rentPaymentFailure">
            1<h1/><Image src={images.game.homeOwner1}/><Say who={people.apartments01Keeper}/>
            <Link to="" callback={()=>{
                people.player.set("money", people.player.money-600);
                jumpTo("game.endDidntPayRent");}}/>
        </Trans>
    </Passage>,

    goBuyPinaColada: <Passage>
        <Trans i18nKey="game.goBuyPinaColada.main">1<h1/><Image src={images.places.supermarket}/></Trans><br/><br/>
        <V callback={
            () => (
                people.player.money >= things.pinaBottle.price ?
                    <Trans i18nKey="story.goBuyPinaColada.link1">1<Link to="story.goBuyPinaColadaSuccess"/></Trans> :
                    <Trans i18nKey="story.goBuyPinaColada.link2">1<Link to="story.goBuyPinaColadaFailure"/></Trans>
            )
        }/>
    </Passage>,

    goBuyPinaColadaSuccess: <Passage>
        <Trans i18nKey="story.goBuyPinaColadaSuccess">
            1<h1/><Image src={images.other.pinaColada}/>
            <Link to="" callback={
                () => {
                    addTimePart(true);
                    missions.initCorruption_01.finishCurrentTask();
                    people.player.set("money", people.player.money - things.pinaBottle.price);
                    currentPlayer.goTo(places.homeBedroom.id);
                }}/>
        </Trans>
    </Passage>,

    goBuyPinaColadaFailure: <Passage>
        <Trans i18nKey="story.goBuyPinaColadaFailure">
            1<h1/><Image src={images.player.drive.van}/>
            <Link to="" callback={
                () => {
                    addTimePart(true);
                    currentPlayer.goTo(places.homeBedroom.id);
                }}/>
        </Trans>
    </Passage>,

    treatWifePill_01kitchen: <Passage>
        <Trans i18nKey="story.treatWifePill_01kitchen">
            1<h1/><Image src={images.other.pinaColada}/><Name who={people.wife}/><Name who={people.wife} nickname/>
            <Link to="story.treatWifePill_01bedroom"/>
        </Trans>
    </Passage>,

    treatWifePill_01bedroom: <Passage>
        <Trans i18nKey="story.treatWifePill_01bedroom">
            1<h1/><Image src={images.story.coupleDrink}/><Name who={people.wife}/><Say who={people.player}/>
            <Say who={people.wife}/><Name who={people.wife} nickname/><Image src={images.story.drinksPina}/><strong/>
            <Link to="" callback={() => {
                addTimePart(true);
                people.wife.set("relations", people.wife.relations + 2);
                missions.initCorruption_01.finishCurrentTask();
                variables.game.dateWifeTreatedPill = variables.game.date;
                currentPlayer.goTo(places.homeKitchen.id);}}/>{{player: people.player.name}}
        </Trans>
    </Passage>,

    pillForJobEffectBegins: <Passage>
        <V callback={() => people.wife.occupations.set(people.wife.occupations.lessons.id)}/>
        <Trans i18nKey="story.pillForJobEffectBegins">
            1<h1/><Image src={images.wife.occupations.lessons.bed}/><Name who={people.wife}/><Say who={people.player}/>
            <Say who={people.wife}/><Name who={people.wife} nickname/>
            <Link to="" callback={() => {
                variables.story.pillForJobEffectBeginsIsShown = true;
                missions.initCorruption_01.tasks.askAtOfficeAboutWife_01.start();
                currentPlayer.goTo(places.homeBathroom.id);}}/>{{player: people.player.name}}
        </Trans>
    </Passage>,

    tellWifeAboutJobInOffice: <Passage>
        <h1><Name who={people.wife}/></h1>
        <Image src={images.wife.actions.speak["02"]}/>
        <Trans i18nKey="story.tellWifeAboutJobInOffice">
            1<Say who={people.player}/><Say who={people.wife}/><Name who={people.wife} nickname/>
            <Name who={people.officeWorker}/><Name who={people.wife}/><Image src={images.wife.actions.argue.arguing0}/>
            <Link to="" callback={()=>{
                missions.initCorruption_01.finishCurrentTask();
                people.wife.set("relations", people.wife.relations - 5);
                jumpTo("story.tellWifeAboutJobInOfficeAfter");}}/>
            {{wife: people.wife.name, player: people.player.name, worker: people.officeWorker.name}}
        </Trans>
    </Passage>,

    tellWifeAboutJobInOfficeAfter: <Passage>
        <Trans i18nKey="story.tellWifeAboutJobInOfficeAfter">
            1<h1/><Image src={images.wife.actions.busy["01"]}/><Name who={people.wife}/><Name who={people.officeWorker}/><h2/><strong/>
            <Link to="game.changeDay" callback={()=>{
                changeTimeTo(0, 0, 7);
                people.player.set("money", people.player.money + constants.works.courier.salaryPerDay * 7);
                people.wife.occupations.set(people.wife.occupations.wakeup.id);
                variables.game.nextDayLink = "game.place";
                places.setCurrent(places.homeBedroom.id);}}/>{{wife: people.wife.name}}
        </Trans>
    </Passage>,

    wifeIsGoingToBathroom: <Passage>
        <h1><Name who={people.wife}/></h1>
        <Image src={images.wife.actions.no}/>
        <Trans i18nKey="story.wifeIsGoingToBathroom">
            1<Say who={people.wife}/>
            <br/><Link to="" callback={()=>{currentPlayer.goTo(places.homeBedroom.id)}}/>
            {{player: people.player.name}}
        </Trans>
    </Passage>,

    wifeOfficeInterview: <Passage>
        <Trans i18nKey="story.wifeOfficeInterview">
            1<h1/><Name who={people.wife}/><Name who={people.officeWorker}/><Image src={images.people.officeWorker}/>
            <Say who={people.officeWorker}/><Say who={people.wife}/><Image src={images.wife.actions.hug.hugOffice}/><br/>
            <Link to="" callback={()=>{
                missions.initCorruption_01.finishCurrentTask()
                addTimePart()
                variables.game.morningSetter = () => {
                    variables.wife.schedule = [
                        ["wakeup", "shower", "officeJob"],
                        ["officeJob", "officeJob", "officeJob"],
                        ["lessons", "reading", "sleep"]
                    ];
                };
                people.player.sendNewMessage("mes05");
                currentPlayer.goTo(places.homeMain.id);
            }}/>
            {{
                wife: people.wife.name, worker: people.officeWorker.name, officeHead: people.officeHead.name,
                player: people.player.name
            }}
        </Trans>
    </Passage>,

    goHome_01: <Passage>
        <Trans i18nKey="story.goHome_01">
            1<h1/><Name who={people.wife}/><Image src={images.wife.actions.hug.hug01}/><Say who={people.player}/>
            <Say who={people.wife}/><strong/><br/>
            <Link to="" callback={()=>{
                missions.initCorruption_01.finishCurrentTask();
                people.wife.set("relations", people.wife.relations + 2);
                currentPlayer.goTo(places.homeBedroom.id);
                notify(
                    <b>This is the end of current main story content in current version, you can play further, but nothing interesting will happen.</b>
                );
            }}/>
            {{worker: people.officeWorker.name}}
        </Trans>
    </Passage>
}, "story");